export const SITE_URL = "https://maielmokadem.com";
const OG_IMAGE = `${SITE_URL}/mai-about-og.jpg`;
const PORTFOLIO_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/albncmqp_image.png";
const FASHION_OG_IMAGE =
  "https://images.unsplash.com/photo-1604828538822-61187f1eb326?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";
const MUSIC_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/np6e07v9_image.png";
const CULTURE_OG_IMAGE =
  "https://images.pexels.com/photos/36176350/pexels-photo-36176350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const INTERVIEWS_OG_IMAGE =
  "https://images.pexels.com/photos/31167801/pexels-photo-31167801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export const PROFILE_SAME_AS = [
  "https://scenenow.com/WriterProfile/2130",
  "https://www.internationalmusicsummit.com/ims-speakers/mai-el-mokadem",
];

export const DEFAULT_SEO = {
  title: "Mai El Mokadem - Writer & Journalist",
  description:
    "Egyptian journalist and freelance writer covering fashion, music, arts, culture, celebrity interviews, and the Middle East creative scene.",
  canonical: `${SITE_URL}/`,
  ogTitle: "Mai El Mokadem - Writer & Journalist",
  ogDescription:
    "Egyptian journalist and freelance writer covering fashion, music, arts, culture, celebrity interviews, and the Middle East creative scene.",
  image: OG_IMAGE,
};

export const ROUTE_SEO = {
  "/": {
    title: "Mai El Mokadem - Freelance Journalist | Egypt",
    description:
      "Mai El Mokadem is an Egyptian journalist and freelance writer based in Cairo. Covering fashion, music, culture and the MENA creative scene for Dazed MENA, Rolling Stone MENA, This Is YUNG and more.",
    canonical: `${SITE_URL}/`,
    ogTitle: "Mai El Mokadem - Freelance Journalist | Egypt",
    ogDescription:
      "Egyptian journalist and freelance writer based in Cairo, covering fashion, music, culture and the MENA creative scene.",
    image: OG_IMAGE,
  },
  "/about": {
    title: "About Mai El Mokadem - Freelance Journalist & Editorial Writer | Egypt",
    description:
      "Egyptian journalist Mai El Mokadem covers fashion, music, culture and identity across the Middle East. Based in Cairo, published in Dazed MENA, Rolling Stone MENA, A Shot Magazine and more.",
    canonical: `${SITE_URL}/about`,
    ogTitle: "About Mai El Mokadem - Freelance Journalist & Editorial Writer",
    ogDescription:
      "Learn about Mai El Mokadem's journalism across fashion, music, culture and identity in Egypt and the Middle East.",
    image: OG_IMAGE,
  },
  "/journalist-portfolio": {
    title: "Freelance Journalist Portfolio - Mai El Mokadem | Cairo, Egypt",
    description:
      "Portfolio of Mai El Mokadem, a freelance journalist based in Cairo, Egypt. Fashion, music and cultural journalism across the MENA region. Published in Dazed MENA, Rolling Stone MENA and more.",
    canonical: `${SITE_URL}/journalist-portfolio`,
    ogTitle: "Freelance Journalist Portfolio - Mai El Mokadem",
    ogDescription:
      "Explore Mai El Mokadem's journalism portfolio across fashion, music, culture and interviews from Cairo and the MENA region.",
    image: PORTFOLIO_OG_IMAGE,
  },
  "/fashion-journalist": {
    title: "Fashion Journalist Egypt & Middle East - Mai El Mokadem",
    description:
      "Fashion journalism by Mai El Mokadem: designer profiles, cover stories and style commentary from Egypt, Cairo and across the Arab world. Scene Styled, Dazed MENA, A Shot Magazine.",
    canonical: `${SITE_URL}/fashion-journalist`,
    ogTitle: "Fashion Journalist Egypt & Middle East - Mai El Mokadem",
    ogDescription:
      "Designer profiles, cover stories and style commentary from Egypt, Cairo and the wider Middle East.",
    image: FASHION_OG_IMAGE,
  },
  "/music-journalist": {
    title: "Music Journalist Middle East - Mai El Mokadem | Arab Music Writing",
    description:
      "Music journalism and cultural commentary by Egyptian journalist Mai El Mokadem. Author of the viral Habibification piece. Writing Arab sonic identity, Egyptian music culture and MENA sound.",
    canonical: `${SITE_URL}/music-journalist`,
    ogTitle: "Music Journalist Middle East - Mai El Mokadem",
    ogDescription:
      "Music journalism on Arab sonic identity, Egyptian music culture and the MENA creative scene.",
    image: MUSIC_OG_IMAGE,
  },
  "/cultural-commentary": {
    title: "Cultural Commentary Middle East - Mai El Mokadem | Egypt Writer",
    description:
      "Long-form cultural essays and commentary by Egyptian journalist Mai El Mokadem. Culture writing on Arab identity, intimacy, film and internet culture in Egypt and the Middle East.",
    canonical: `${SITE_URL}/cultural-commentary`,
    ogTitle: "Cultural Commentary Middle East - Mai El Mokadem",
    ogDescription:
      "Long-form essays on Arab identity, intimacy, film and internet culture in Egypt and the Middle East.",
    image: CULTURE_OG_IMAGE,
  },
  "/interviews": {
    title: "Celebrity Interviews - Mai El Mokadem | Middle East Journalist",
    description:
      "Cover interviews and creative conversations by Mai El Mokadem. In-depth profiles of regional and global artists, designers and cultural figures for A Shot Magazine, Scene Styled and more.",
    canonical: `${SITE_URL}/interviews`,
    ogTitle: "Celebrity Interviews - Mai El Mokadem",
    ogDescription:
      "Cover interviews and in-depth profiles of regional and global artists, designers and cultural figures.",
    image: INTERVIEWS_OG_IMAGE,
  },
  "/contact": {
    title: "Contact Mai El Mokadem - Freelance Journalist",
    description:
      "Contact Mai El Mokadem for journalism commissions, interviews, editorial projects and creative collaborations.",
    canonical: `${SITE_URL}/contact`,
    ogTitle: "Contact Mai El Mokadem - Freelance Journalist",
    ogDescription:
      "Get in touch with Mai El Mokadem for journalism commissions, interviews and editorial collaborations.",
    image: OG_IMAGE,
  },
};
